import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { HttpService } from "../../shared/services/http.service";
import { AppConfig } from "../../app.config";
import { AuthService } from "./auth.service";
import { UserDetail } from "../../models/userDetail";
import { ManagedUser } from "../../models/managedUser";
import { HttpHeaders } from "@angular/common/http";
import { map, retry } from "rxjs/operators";

const RUNFILE_ACCESS_GROUPS = ["access:runfile_view"];
const TRACEFIT_ACCESS_GROUPS = ["trace_fit_view"];
const COMPUTE_ADMIN_GROUPS = ["admin:compute-access"];
const XWAI_ACCESS_ROLE = ["access:XWAI"];

@Injectable()
export class UserService {
  constructor(private http: HttpService, private authService: AuthService) {}

  getUserDetails(): Observable<UserDetail> {
    return this.http
      .get(
        `${AppConfig.settings.apiUrl}/users/self/`,
        this.getAuthorizationHeader()
      )
      .pipe(
        retry(2),
        map((response) => {
          if (!response) return;

          let data = response;
          let runfileAccess: boolean;
          let computeAdminAccess: boolean;
          if (Array.isArray(data.jwt_roles)) {
            computeAdminAccess = data.jwt_roles.some((group) => {
              return COMPUTE_ADMIN_GROUPS.includes(group);
            });
            runfileAccess =
              data.jwt_roles?.some((group) => {
                return RUNFILE_ACCESS_GROUPS.includes(group);
              }) || false;
          } else if (typeof data.jwt_roles === "string") {
            computeAdminAccess = COMPUTE_ADMIN_GROUPS.includes(data.jwt_roles);
            runfileAccess = RUNFILE_ACCESS_GROUPS.includes(data.jwt_roles);
          } else if (data.isStaff) {
            runfileAccess = true;
            computeAdminAccess = false;
          } else {
            runfileAccess = false;
            computeAdminAccess = false;
          }

          let xwaiAccess = data.is_staff || data.email == "general@seimax.com" || data.jwt_roles.some((group: string) => {
              return XWAI_ACCESS_ROLE.includes(group);
            });;
          return {
            id: data.id,
            groupName: data.billing_group,
            isStaff: data.is_staff,
            email: data.email,
            xwaiAccess: xwaiAccess,
            all_users: data.all_users,
            runfileAccess: runfileAccess,
            tracefitAccess: data.user_groups.some((group) => {
              return TRACEFIT_ACCESS_GROUPS.includes(group);
            }),
            isComputeAdmin: computeAdminAccess,
          };
        })
      );
  }

  getBillingGroupAdmin(groupName: string): Observable<string> {
    return this.http
      .get(
        `${AppConfig.settings.apiUrl}/billing_groups/${groupName}/`,
        this.getAuthorizationHeader()
      )
      .pipe(
        retry(2),
        map((response) => {
          if (!response) return;

          let data = response;
          if (!data) return null;

          return data.billing_admin_user;
        })
      );
  }

  private getAuthorizationHeader(): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      this.authService.getTokenHeaderText()
    );
    return { headers };
  }
}
